const createStepDataLayer = (
	event: string,
	page: string,
	pageName: string,
	step: string
): Object => {
	return {
		event,
		page,
		PageName: pageName,
		step,
	};
};

const createFinishDataLayer = (
	event: string,
	page: string,
	pageName: string,
	email?: string
): Object => {
	if (email) {
		return {
			event,
			page,
			PageName: pageName,
			email,
		};
	} else {
		return {
			event,
			page,
			PageName: pageName,
		};
	}
};

const createDataLayer = (
	event: string,
	page: string,
	pageName: string,
	step: string,
	flow: string
): Object => {
	return {
		event,
		page,
		PageName: pageName,
		flujo: flow,
		step,
	};
};

const createNewDataLayer = (
	event: string,
	page: string,
	pageName: string,
	step: string,
	flow: string,
	crmId?: string
): Object => {
	return {
		event,
		page,
		PageName: pageName,
		flujo: flow,
		step,
		id_humano: crmId,
	};
};

const getHashEmailFromStorage = (): string | undefined => {
	if (sessionStorage.getItem('HASH_EMAIL') != null) {
		const email = sessionStorage.getItem('HASH_EMAIL') as string;
		return JSON.parse(email).hash as string;
	} else {
		return undefined;
	}
};

const getCRMIDFromStorage = (): string | undefined => {
	if (sessionStorage.getItem('CMR_ID') != null) {
		const email = sessionStorage.getItem('CMR_ID') as string;
		return JSON.parse(email)?.crmIdentifier as string;
	}
};

const DATA_LAYER_EVENT = 'vpv';

export const DATA_LAYER_FLOW = { LOAN: 'Crédito Automotríz', REFINANCING: 'Refinanciamiento' };

export const DATA_LAYER_RESPONSE_KEY = {
	PORTABILITY_MULTI_FORM_6_EXITO: 'portabilidad-multi-form-exito',
	PORTABILITY_MULTI_FORM_6_ERROR: 'portabilidad-multi-form-error',
	PORTABILITY_MULTI_FORM_6_LO_SENTIMOS: 'portabilidad-multi-form-lo-sentimos',
	//LOAN AUTOATENCION
	LOAN_AUTOATENCION_BIENVENIDA: 'autoatencion-bienvenida',
	LOAN_AUTOATENCION_INFO_PERSONAL: 'autoatencion-info-personal',
	LOAN_AUTOATENCION_INFO_PERSONAL_RECHAZO: 'autoatencion-info-personal-rechazo',
	LOAN_AUTOATENCION_INFO_VEHICULO: 'autoatencion-info-personal-vehiculo',
	LOAN_AUTOATENCION_SCORING_RECHAZO: 'autoatencion-scoring-rechazo',
	LOAN_AUTOATENCION_SIMULACION: 'autoatencion-simulacion',
	LOAN_AUTOATENCION_MODAL_DOCUMENTOS: 'autoatencion-modal-documentos',
	LOAN_AUTOATENCION_SIN_DOCUMENTOS: 'autoatencion-sin-documentos',
	LOAN_AUTOATENCION_ADJUNTAR_DOCUMENTOS: 'autoatencion-adjuntar-documentos',
	LOAN_AUTOATENCION_AYUDA_DOCUMENTOS: 'autoatencion-ayuda-documentos',
	LOAN_AUTOATENCION_DOCUMENTOS_ENVIADOS: 'autoatencion-documentos-enviados',
	LOAN_AUTOATENCION_DOCUMENTOS_ERROR_SERVICIO: 'autoatencion-documentos-error-servicio',
	//LOAN NORMAL
	LOAN_NORMAL_INFO_PERSONAL: 'credito-normal-info-personal',
	LOAN_NORMAL_RECHAZO_KO: 'credito-normal-rechazo-ko',
	LOAN_NORMAL_INFO_VEHICULO: 'credito-normal-info-vehiculo',
	LOAN_NORMAL_SOLICITUD_ENVIADA: 'credito-normal-solicitud-enviada',
	//LOAN_MOTO
	LOAN_MOTO_INFO_PERSONAL: 'credito-normal-info-personal',
	LOAN_MOTO_INFO_VEHICULO: 'credito-normal-info-vehiculo',
	//LOAN_AUTOFINANCIAMIENTO
	LOAN_AUTOFINANCIAMIENTO_INFO_PERSONAL: 'credito-normal-info-personal',
	LOAN_AUTOFINANCIAMIENTO_INFO_VEHICULO: 'credito-normal-info-vehiculo',
	//REFINANCIAMIENTO
	REFINANCING_INFO_PERSONAL: 'refinanciamiento-info-personal',
	REFINANCING_INFO_VEHICULO: 'refinanciamiento-info-vehiculo',
	REFINANCING_SOLICITUD_EXITOSA: 'refinanciamiento-solicitud-exitosa',
	REFINANCING_ERROR_SERVICIO: 'refinanciamiento-error-servicio',
	REFINANCING_RECHAZO_KO: 'refinanciamiento-rechazo-ko',
	//QUOTATION
	QUOTATION_FORM: 'cotizacion-simple',
	//CREDITO LIQUIDACION
	CREDIT_LIQUIDATION_INFO_PERSONAL: 'credit-liquidation-info-personal',
	CREDIT_LIQUIDATION_INFO_ENTITY: 'credit-liquidation-info-entity',
	CREDIT_LIQUIDATION_BIENVENIDA: 'credit-liquidation-bienvenida',
};

export const DATA_LAYER_PAGE = {
	PAGE_PORTABILITY_MULTI_FORM_6_STEP_1: '/portabilidad/form-6-step-1',
	PAGE_PORTABILITY_MULTI_FORM_6_STEP_2: '/portabilidad/form-6-step-2',
	PAGE_PORTABILITY_MULTI_FORM_6_STEP_3: '/portabilidad/form-6-step-3',
	PAGE_PORTABILITY_MULTI_FORM_6_STEP_4: '/portabilidad/form-6-step-4',
	PAGE_PORTABILITY_MULTI_FORM_6_STEP_5: '/portabilidad/form-6-step-5',
	PAGE_PORTABILITY_MULTI_FORM_6_STEP_6: '/portabilidad/form-6-step-6',
	//PAGES RESPONSE 6 PASOS
	PAGE_PORTABILITY_MULTI_FORM_6_EXITO: '/portabilidad/form-6-exito',
	PAGE_PORTABILITY_MULTI_FORM_6_LO_SENTIMOS: '/portabilidad/form-6-lo-sentimos',
	PAGE_PORTABILITY_MULTI_FORM_6_ERROR: '/portabilidad/form-6-error',
	//LOAN AUTOATENCION
	PAGE_LOAN_AUTOATENCION_BIENVENIDA: '/autoatencion/bienvenida',
	PAGE_LOAN_AUTOATENCION_INFO_PERSONAL: '/autoatencion/info-personal',
	PAGE_LOAN_AUTOATENCION_INFO_PERSONAL_RECHAZO: '/autoatencion/info-personal-rechazo',
	PAGE_LOAN_AUTOATENCION_INFO_VEHICULO: '/autoatencion/info-vehiculo',
	PAGE_LOAN_AUTOATENCION_SCORING_RECHAZO: '/autoatencion/scoring-rechazo',
	PAGE_LOAN_AUTOATENCION_SIMULACION: '/autoatencion/resultado-simulacion',
	PAGE_LOAN_AUTOATENCION_MODAL_DOCUMENTOS: '/autoatencion/modal-documentos',
	PAGE_LOAN_AUTOATENCION_SIN_DOCUMENTOS: '/autoatencion/sin-documentos',
	PAGE_LOAN_AUTOATENCION_ADJUNTAR_DOCUMENTOS: '/autoatencion/adjuntar-documentos',
	PAGE_LOAN_AUTOATENCION_AYUDA_DOCUMENTOS: '/autoatencion/ayuda-documentos',
	PAGE_LOAN_AUTOATENCION_DOCUMENTOS_ENVIADOS: '/autoatencion/documentos-enviados',
	PAGE_LOAN_AUTOATENCION_DOCUMENTOS_ERROR_SERVICIO: '/autoatencion/documentos-error-servicio',
	//LOAN NORMAL
	PAGE_LOAN_NORMAL_INFO_PERSONAL: '/atencion-normal/info-personal',
	PAGE_LOAN_NORMAL_RECHAZO_KO: '/atencion-normal/info-personal/rechazo-ko',
	PAGE_LOAN_NORMAL_INFO_VEHICULO: '/atencion-normal/info-vehiculo',
	PAGE_LOAN_NORMAL_SOLICITUD_ENVIADA: '/atencion-normal/solicitud-enviada',
	//REFINANCIAMIENTO
	PAGE_REFINANCING_INFO_PERSONAL: '/refinanciamiento/info-personal',
	PAGE_REFINANCING_INFO_VEHICULO: '/refinanciamiento/info-vehiculo',
	PAGE_REFINANCING_SOLICITUD_EXITOSA: '/refinanciamiento/solicitud-exitosa',
	PAGE_REFINANCING_ERROR_SERVICIO: '/refinanciamiento/error-servicio',
	PAGE_REFINANCING_RECHAZO_KO: '/refinanciamiento/rechazo-ko',
};

export const DATA_LAYER_PAGE_NAME = {
	PAGE_NAME_USER_NAMES: 'User Names',
	PAGE_NAME_USER_CONTACT: 'User Contact',
	PAGE_NAME_USER_PERSONAL_INFO: 'User Personal Info',
	PAGE_NAME_USER_CREDIT_INFO: 'User Credit Info',
	PAGE_NAME_USER_FINANCIAL_INSTITUTION: 'User Financial Institution',
	PAGE_NAME_USER_ADDRESS: 'User Address',
	PAGE_NAME_PORTABILITY_SINGLE_FORM: 'Single Form',
	PAGE_NAME_PORTABILITY_FORM_6_EXITO: 'Portabilidad Exito - Form 6',
	PAGE_NAME_PORTABILITY_FORM_6_LO_SENTIMOS: 'Portabilidad Lo sentimos - Form 6',
	PAGE_NAME_PORTABILITY_FORM_6_ERROR: 'Portabilidad Error - Form 6',
	PAGE_NAME_PORTABILITY_FORM_1_EXITO: 'Portabilidad Exito - Single Form',
	PAGE_NAME_PORTABILITY_FORM_1_LO_SENTIMOS: 'Portabilidad Lo Sentimos - Single Form',
	PAGE_NAME_PORTABILITY_FORM_1_LO_ERROR: 'Portabilidad Error - Single Form',
	//LOAN AUTOATENCION
	PAGE_NAME_LOAN_AUTOATENCION_BIENVENIDA: 'Bienvenida - Autoatención',
	PAGE_NAME_LOAN_AUTOATENCION_INFO_PERSONAL: 'Información personal - Autoatención',
	PAGE_NAME_LOAN_AUTOATENCION_INFO_PERSONAL_RECHAZO:
		'Información personal - rechazo - Autoatención',
	PAGE_NAME_LOAN_AUTOATENCION_INFO_VEHICULO: 'Información de vehículo - Autoatención',
	PAGE_NAME_LOAN_AUTOATENCION_SCORING_RECHAZO: 'Scoring - rechazo - Autoatención',
	PAGE_NAME_LOAN_AUTOATENCION_SIMULACION: 'Resultado Simulación - Autoatención',
	PAGE_NAME_LOAN_AUTOATENCION_MODAL_DOCUMENTOS: 'Modal documentos - Autoatención',
	PAGE_NAME_LOAN_AUTOATENCION_SIN_DOCUMENTOS: 'Sin documentos - Autoatención',
	PAGE_NAME_LOAN_AUTOATENCION_ADJUNTAR_DOCUMENTOS: 'Adjuntar documentos - Autoatención',
	PAGE_NAME_LOAN_AUTOATENCION_AYUDA_DOCUMENTOS: 'Ayuda documentos - Autoatención',
	PAGE_NAME_LOAN_AUTOATENCION_DOCUMENTOS_ENVIADOS: 'Documentos enviados - Autoatención',
	PAGE_NAME_LOAN_AUTOATENCION_DOCUMENTOS_ERROR_SERVICIO: 'Error de servicio - Autoatención',
	//LOAN NORMAL
	PAGE_NAME_LOAN_NORMAL_INFO_PERSONAL: 'Información personal - Atención Normal',
	PAGE_NAME_LOAN_NORMAL_RECHAZO_KO: 'Información personal - rechazo - Atención Normal',
	PAGE_NAME_LOAN_NORMAL_INFO_VEHICULO: 'Información de vehículo - Atención Normal',
	PAGE_NAME_LOAN_NORMAL_SOLICITUD_ENVIADA: 'Solicitud enviada - Atención Normal',
	//REFINANCIAMIENTO
	PAGE_NAME_REFINANCING_INFO_PERSONAL: 'Información personal - Refinanciamiento',
	PAGE_NAME_REFINANCING_INFO_VEHICULO: 'Información de vehículo - Refinanciamiento',
	PAGE_NAME_REFINANCING_SOLICITUD_EXITOSA: 'Solicitud exitosa - Refinanciamiento',
	PAGE_NAME_REFINANCING_ERROR_SERVICIO: 'Error de servicio - Refinanciamiento',
	PAGE_NAME_REFINANCING_RECHAZO_KO: 'Rechazo - Refinanciamiento',
};

export const DATA_LAYERS = new Map<string, Object>([
	[
		DATA_LAYER_PAGE.PAGE_PORTABILITY_MULTI_FORM_6_STEP_1,
		createStepDataLayer(
			DATA_LAYER_EVENT,
			DATA_LAYER_PAGE.PAGE_PORTABILITY_MULTI_FORM_6_STEP_1,
			DATA_LAYER_PAGE_NAME.PAGE_NAME_USER_NAMES,
			'1'
		),
	],
	[
		DATA_LAYER_PAGE.PAGE_PORTABILITY_MULTI_FORM_6_STEP_2,
		createStepDataLayer(
			DATA_LAYER_EVENT,
			DATA_LAYER_PAGE.PAGE_PORTABILITY_MULTI_FORM_6_STEP_2,
			DATA_LAYER_PAGE_NAME.PAGE_NAME_USER_CONTACT,
			'2'
		),
	],
	[
		DATA_LAYER_PAGE.PAGE_PORTABILITY_MULTI_FORM_6_STEP_3,
		createStepDataLayer(
			DATA_LAYER_EVENT,
			DATA_LAYER_PAGE.PAGE_PORTABILITY_MULTI_FORM_6_STEP_3,
			DATA_LAYER_PAGE_NAME.PAGE_NAME_USER_PERSONAL_INFO,
			'3'
		),
	],
	[
		DATA_LAYER_PAGE.PAGE_PORTABILITY_MULTI_FORM_6_STEP_4,
		createStepDataLayer(
			DATA_LAYER_EVENT,
			DATA_LAYER_PAGE.PAGE_PORTABILITY_MULTI_FORM_6_STEP_4,
			DATA_LAYER_PAGE_NAME.PAGE_NAME_USER_CREDIT_INFO,
			'4'
		),
	],
	[
		DATA_LAYER_PAGE.PAGE_PORTABILITY_MULTI_FORM_6_STEP_5,
		createStepDataLayer(
			DATA_LAYER_EVENT,
			DATA_LAYER_PAGE.PAGE_PORTABILITY_MULTI_FORM_6_STEP_5,
			DATA_LAYER_PAGE_NAME.PAGE_NAME_USER_FINANCIAL_INSTITUTION,
			'5'
		),
	],
	[
		DATA_LAYER_PAGE.PAGE_PORTABILITY_MULTI_FORM_6_STEP_6,
		createStepDataLayer(
			DATA_LAYER_EVENT,
			DATA_LAYER_PAGE.PAGE_PORTABILITY_MULTI_FORM_6_STEP_6,
			DATA_LAYER_PAGE_NAME.PAGE_NAME_USER_ADDRESS,
			'6'
		),
	],
	[
		DATA_LAYER_RESPONSE_KEY.PORTABILITY_MULTI_FORM_6_EXITO,
		createFinishDataLayer(
			DATA_LAYER_EVENT,
			DATA_LAYER_PAGE.PAGE_PORTABILITY_MULTI_FORM_6_EXITO,
			DATA_LAYER_PAGE_NAME.PAGE_NAME_PORTABILITY_FORM_6_EXITO,
			getHashEmailFromStorage()
		),
	],
	[
		DATA_LAYER_RESPONSE_KEY.PORTABILITY_MULTI_FORM_6_LO_SENTIMOS,
		createFinishDataLayer(
			DATA_LAYER_EVENT,
			DATA_LAYER_PAGE.PAGE_PORTABILITY_MULTI_FORM_6_LO_SENTIMOS,
			DATA_LAYER_PAGE_NAME.PAGE_NAME_PORTABILITY_FORM_6_LO_SENTIMOS,
			getHashEmailFromStorage()
		),
	],
	[
		DATA_LAYER_RESPONSE_KEY.PORTABILITY_MULTI_FORM_6_ERROR,
		createFinishDataLayer(
			DATA_LAYER_EVENT,
			DATA_LAYER_PAGE.PAGE_PORTABILITY_MULTI_FORM_6_ERROR,
			DATA_LAYER_PAGE_NAME.PAGE_NAME_PORTABILITY_FORM_6_ERROR,
			getHashEmailFromStorage()
		),
	],
	// LOAN AUTOATENCION
	[
		DATA_LAYER_RESPONSE_KEY.LOAN_AUTOATENCION_BIENVENIDA,
		createDataLayer(
			DATA_LAYER_EVENT,
			DATA_LAYER_PAGE.PAGE_LOAN_AUTOATENCION_BIENVENIDA,
			DATA_LAYER_PAGE_NAME.PAGE_NAME_LOAN_AUTOATENCION_BIENVENIDA,
			'1',
			DATA_LAYER_FLOW.LOAN
		),
	],
	[
		DATA_LAYER_RESPONSE_KEY.LOAN_AUTOATENCION_INFO_PERSONAL,
		createDataLayer(
			DATA_LAYER_EVENT,
			DATA_LAYER_PAGE.PAGE_LOAN_AUTOATENCION_INFO_PERSONAL,
			DATA_LAYER_PAGE_NAME.PAGE_NAME_LOAN_AUTOATENCION_INFO_PERSONAL,
			'2',
			DATA_LAYER_FLOW.LOAN
		),
	],
	[
		DATA_LAYER_RESPONSE_KEY.LOAN_AUTOATENCION_INFO_PERSONAL_RECHAZO,
		createDataLayer(
			DATA_LAYER_EVENT,
			DATA_LAYER_PAGE.PAGE_LOAN_AUTOATENCION_INFO_PERSONAL_RECHAZO,
			DATA_LAYER_PAGE_NAME.PAGE_NAME_LOAN_AUTOATENCION_INFO_PERSONAL_RECHAZO,
			'2.1',
			DATA_LAYER_FLOW.LOAN
		),
	],
	[
		DATA_LAYER_RESPONSE_KEY.LOAN_AUTOATENCION_INFO_VEHICULO,
		createDataLayer(
			DATA_LAYER_EVENT,
			DATA_LAYER_PAGE.PAGE_LOAN_AUTOATENCION_INFO_VEHICULO,
			DATA_LAYER_PAGE_NAME.PAGE_NAME_LOAN_AUTOATENCION_INFO_VEHICULO,
			'3',
			DATA_LAYER_FLOW.LOAN
		),
	],
	[
		DATA_LAYER_RESPONSE_KEY.LOAN_AUTOATENCION_SCORING_RECHAZO,
		createDataLayer(
			DATA_LAYER_EVENT,
			DATA_LAYER_PAGE.PAGE_LOAN_AUTOATENCION_SCORING_RECHAZO,
			DATA_LAYER_PAGE_NAME.PAGE_NAME_LOAN_AUTOATENCION_SCORING_RECHAZO,
			'3.1',
			DATA_LAYER_FLOW.LOAN
		),
	],
	[
		DATA_LAYER_RESPONSE_KEY.LOAN_AUTOATENCION_SIMULACION,
		createNewDataLayer(
			DATA_LAYER_EVENT,
			DATA_LAYER_PAGE.PAGE_LOAN_AUTOATENCION_SIMULACION,
			DATA_LAYER_PAGE_NAME.PAGE_NAME_LOAN_AUTOATENCION_SIMULACION,
			'4',
			DATA_LAYER_FLOW.LOAN,
			getCRMIDFromStorage()
		),
	],
	[
		DATA_LAYER_RESPONSE_KEY.LOAN_AUTOATENCION_MODAL_DOCUMENTOS,
		createDataLayer(
			DATA_LAYER_EVENT,
			DATA_LAYER_PAGE.PAGE_LOAN_AUTOATENCION_MODAL_DOCUMENTOS,
			DATA_LAYER_PAGE_NAME.PAGE_NAME_LOAN_AUTOATENCION_MODAL_DOCUMENTOS,
			'5',
			DATA_LAYER_FLOW.LOAN
		),
	],
	[
		DATA_LAYER_RESPONSE_KEY.LOAN_AUTOATENCION_SIN_DOCUMENTOS,
		createDataLayer(
			DATA_LAYER_EVENT,
			DATA_LAYER_PAGE.PAGE_LOAN_AUTOATENCION_SIN_DOCUMENTOS,
			DATA_LAYER_PAGE_NAME.PAGE_NAME_LOAN_AUTOATENCION_SIN_DOCUMENTOS,
			'5.1',
			DATA_LAYER_FLOW.LOAN
		),
	],
	[
		DATA_LAYER_RESPONSE_KEY.LOAN_AUTOATENCION_ADJUNTAR_DOCUMENTOS,
		createDataLayer(
			DATA_LAYER_EVENT,
			DATA_LAYER_PAGE.PAGE_LOAN_AUTOATENCION_ADJUNTAR_DOCUMENTOS,
			DATA_LAYER_PAGE_NAME.PAGE_NAME_LOAN_AUTOATENCION_ADJUNTAR_DOCUMENTOS,
			'6',
			DATA_LAYER_FLOW.LOAN
		),
	],
	[
		DATA_LAYER_RESPONSE_KEY.LOAN_AUTOATENCION_AYUDA_DOCUMENTOS,
		createDataLayer(
			DATA_LAYER_EVENT,
			DATA_LAYER_PAGE.PAGE_LOAN_AUTOATENCION_AYUDA_DOCUMENTOS,
			DATA_LAYER_PAGE_NAME.PAGE_NAME_LOAN_AUTOATENCION_AYUDA_DOCUMENTOS,
			'6.1',
			DATA_LAYER_FLOW.LOAN
		),
	],
	[
		DATA_LAYER_RESPONSE_KEY.LOAN_AUTOATENCION_DOCUMENTOS_ENVIADOS,
		createDataLayer(
			DATA_LAYER_EVENT,
			DATA_LAYER_PAGE.PAGE_LOAN_AUTOATENCION_DOCUMENTOS_ENVIADOS,
			DATA_LAYER_PAGE_NAME.PAGE_NAME_LOAN_AUTOATENCION_DOCUMENTOS_ENVIADOS,
			'7',
			DATA_LAYER_FLOW.LOAN
		),
	],
	[
		DATA_LAYER_RESPONSE_KEY.LOAN_AUTOATENCION_DOCUMENTOS_ERROR_SERVICIO,
		createDataLayer(
			DATA_LAYER_EVENT,
			DATA_LAYER_PAGE.PAGE_LOAN_AUTOATENCION_DOCUMENTOS_ERROR_SERVICIO,
			DATA_LAYER_PAGE_NAME.PAGE_NAME_LOAN_AUTOATENCION_DOCUMENTOS_ERROR_SERVICIO,
			'7.1',
			DATA_LAYER_FLOW.LOAN
		),
	],
	[
		DATA_LAYER_RESPONSE_KEY.LOAN_NORMAL_INFO_PERSONAL,
		createDataLayer(
			DATA_LAYER_EVENT,
			DATA_LAYER_PAGE.PAGE_LOAN_NORMAL_INFO_PERSONAL,
			DATA_LAYER_PAGE_NAME.PAGE_NAME_LOAN_NORMAL_INFO_PERSONAL,
			'1',
			DATA_LAYER_FLOW.LOAN
		),
	],
	[
		DATA_LAYER_RESPONSE_KEY.LOAN_NORMAL_RECHAZO_KO,
		createDataLayer(
			DATA_LAYER_EVENT,
			DATA_LAYER_PAGE.PAGE_LOAN_NORMAL_RECHAZO_KO,
			DATA_LAYER_PAGE_NAME.PAGE_NAME_LOAN_NORMAL_RECHAZO_KO,
			'1.2',
			DATA_LAYER_FLOW.LOAN
		),
	],
	[
		DATA_LAYER_RESPONSE_KEY.LOAN_NORMAL_INFO_VEHICULO,
		createDataLayer(
			DATA_LAYER_EVENT,
			DATA_LAYER_PAGE.PAGE_LOAN_NORMAL_INFO_VEHICULO,
			DATA_LAYER_PAGE_NAME.PAGE_NAME_LOAN_NORMAL_INFO_VEHICULO,
			'2',
			DATA_LAYER_FLOW.LOAN
		),
	],
	[
		DATA_LAYER_RESPONSE_KEY.LOAN_NORMAL_SOLICITUD_ENVIADA,
		createDataLayer(
			DATA_LAYER_EVENT,
			DATA_LAYER_PAGE.PAGE_LOAN_NORMAL_SOLICITUD_ENVIADA,
			DATA_LAYER_PAGE_NAME.PAGE_NAME_LOAN_NORMAL_SOLICITUD_ENVIADA,
			'2',
			DATA_LAYER_FLOW.LOAN
		),
	],
	[
		DATA_LAYER_RESPONSE_KEY.REFINANCING_INFO_PERSONAL,
		createDataLayer(
			DATA_LAYER_EVENT,
			DATA_LAYER_PAGE.PAGE_REFINANCING_INFO_PERSONAL,
			DATA_LAYER_PAGE_NAME.PAGE_NAME_REFINANCING_INFO_PERSONAL,
			'1',
			DATA_LAYER_FLOW.REFINANCING,
		),
	],
	[
		DATA_LAYER_RESPONSE_KEY.REFINANCING_INFO_VEHICULO,
		createDataLayer(
			DATA_LAYER_EVENT,
			DATA_LAYER_PAGE.PAGE_REFINANCING_INFO_VEHICULO,
			DATA_LAYER_PAGE_NAME.PAGE_NAME_REFINANCING_INFO_VEHICULO,
			'2',
			DATA_LAYER_FLOW.REFINANCING,
		),
	],
	[
		DATA_LAYER_RESPONSE_KEY.REFINANCING_SOLICITUD_EXITOSA,
		createNewDataLayer(
			DATA_LAYER_EVENT,
			DATA_LAYER_PAGE.PAGE_REFINANCING_SOLICITUD_EXITOSA,
			DATA_LAYER_PAGE_NAME.PAGE_NAME_REFINANCING_SOLICITUD_EXITOSA,
			'3',
			DATA_LAYER_FLOW.REFINANCING,
			getCRMIDFromStorage()
		),
	],
	[
		DATA_LAYER_RESPONSE_KEY.REFINANCING_ERROR_SERVICIO,
		createNewDataLayer(
			DATA_LAYER_EVENT,
			DATA_LAYER_PAGE.PAGE_REFINANCING_ERROR_SERVICIO,
			DATA_LAYER_PAGE_NAME.PAGE_NAME_REFINANCING_ERROR_SERVICIO,
			'3',
			DATA_LAYER_FLOW.REFINANCING,
			'123'
		),
	],
	[
		DATA_LAYER_RESPONSE_KEY.REFINANCING_RECHAZO_KO,
		createNewDataLayer(
			DATA_LAYER_EVENT,
			DATA_LAYER_PAGE.PAGE_REFINANCING_RECHAZO_KO,
			DATA_LAYER_PAGE_NAME.PAGE_NAME_REFINANCING_RECHAZO_KO,
			'3',
			DATA_LAYER_FLOW.REFINANCING,
			getCRMIDFromStorage()
		),
	],
]);
